module.exports = __webpack_public_path__ + "static/media/CardDataAnalytics.b90e2b8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/dataAnalytics/CardDataAnalytics.png
// module id = 104
// module chunks = 0